import { apiGetRequest, apiPostRequest } from '../utils/webrequests';
import { EventQuestionnaire } from '../data/questionnaire';

/**
 * Fetch questionnaire for a specific event.
 * @param eventId - The ID of the event.
 */
export async function getQuestionnaire(eventId: string): Promise<EventQuestionnaire | null> {
    try {
        console.log("Fetching Questionnaire for Event ID:", eventId);
        const responseText = await apiGetRequest(`getQuestionnaire/${eventId}`, null);

        const response: EventQuestionnaire = typeof responseText === "string"
            ? JSON.parse(responseText)
            : responseText;

        if (!response || !response.eventId || !Array.isArray(response.questions)) {
            console.warn("Invalid questionnaire response:", response);
            return null;
        }

        console.log("Questionnaire Response:", response);
        return response;
    } catch (error: any) {
        console.error("Failed to fetch questionnaire:", error.message);
        return null;
    }
}

/**
 * Save (create or update) a questionnaire.
 * @param eventId - The ID of the event.
 * @param questionnaire - The questionnaire object to save.
 * @returns The saved questionnaire object.
 */
export async function saveQuestionnaire(eventId: string, questionnaire: EventQuestionnaire): Promise<EventQuestionnaire> {
    try {
        console.log("Saving Questionnaire:", questionnaire);
        await apiPostRequest(`saveQuestionnaire/${eventId}`, questionnaire);
        return questionnaire;
    } catch (error: any) {
        console.error("Error saving questionnaire:", error.message);
        throw new Error("Failed to save questionnaire");
    }
}
/**
 * Delete the questionnaire for a specific event.
 * @param eventId - The ID of the event to delete the questionnaire for.
 */
export async function deleteQuestionnaire(eventId: string): Promise<boolean> {
    try {
        console.log("Deleting Questionnaire:", eventId);
        await apiPostRequest(`deleteQuestionnaire/${eventId}`, {});
        return true;
    } catch (error: any) {
        console.error("Error deleting questionnaire:", error.message);
        return false;
    }
}